import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { Table } from 'primeng/table';
import * as moment from 'moment';
import { ActivatedRoute } from '@angular/router';
import { async } from 'rxjs/internal/scheduler/async';
import { GroupByPipePipe } from 'src/app/pipes/group-by-pipe.pipe';

@Component({
  selector: 'app-dashboard-invoice',
  templateUrl: './dashboard-invoice.component.html',
  styleUrls: ['./dashboard-invoice.component.scss'],
})
export class DashboardInvoiceComponent implements OnInit {
  @ViewChild('calendar') private calendar: any;
  
  accordianIndex: any;
  breadcrumb = [
    {
      title: 'Renewal Reports',
      subTitle: 'Dashboard',
    },
  ];
  cols: any = [];
  list: any = [];
  Datalength: any;
  filterVal: string = '';
  tooltipText: string = environment.resetTooltip;
  filteredXLSData: any[];
  filteredPDFData: any[];
  pdfData: any[];
  excelData: any[];
  @ViewChild('dt1') dataTable: Table;
  exportColumns: any = [];
  renewalHistory: any = [];
  memberdata: any = [];
  hasmember: string = '';
  totalAmount = 0;
  localStorage: any;
  roleName: any;
  from: string;
  to: string;
  totalData: any = [];
  voterYear: any;
  status: boolean = false;
  ucciBaseUrl = environment.ucci_base_url;
  slug: any;
  rangeDates: Date[];
  duplicateMember:any = []
  yearJson: any = [
    {
      name: 'Select Year',
    },
    {
      name: 2023,
    },
    {
      name: 2024,
    },
    {
      name: 2025,
    },
    {
      name: 2026,
    },
    {
      name: 2027,
    },
    {
      name: 2028,
    },
    {
      name: 2029,
    },
    {
      name: 2030,
    },
    {
      name: 2031,
    },
    {
      name: 2032,
    },
    {
      name: 2033,
    },
  ];
  pdfData2: any=[];
  pdfData3: any;
  tableData2:any=[]
  tableData3:any=[]

  yearsOfRenewal: any=[];
  tableData4: any=[];
  excelData2: any;
  excelData3: any;
  excelData4: any;
  year: any;
  membership:any;
searchbox:any
selectedFilterOption: any;
filterOptions:any[]=[
  {label:'Waste Disposed with Manifest',value:'waste_disposed_with_manifest'},
  {label:'Waste Disposed without Manifest',value:'waste_disposed_without_manifest'},
  {label:'Active with UCCI',value:'active_with_ucci'},
]
statusKeys: string[] = [];
groupedData: any = {};
@ViewChild('globalTable') globalTable: any;
flatData: any[] = [];
fullFlatData:any[]=[]
searching: boolean = false;
  memberid: any;
  memeberdatabyid: any;
  constructor(
    private api_service: ApiService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute
  ) {}

  async ngOnInit(): Promise<void> {
    // this.localStorage = JSON.parse(localStorage.getItem('UserObject'));
    // this.roleName = this.localStorage.roleName
    this.cols = [
      { field: 'sr_no', header: 'Sr No' },
      { field: 'companyName', header: 'Company Name' },
      { field: 'membershipNo', header: 'Membership No' },
      { field: 'amount', header: 'Amount' },
      { field: 'membershipYear', header: 'Membership Year' },
      { field: 'membershipType', header: 'Membership Type' },
      { field: 'email', header: 'Email' },
      { field: 'expiringDate', header: 'Expiring Date' },
    ];
    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));
    console.log(this.route.snapshot.params.slug);
    this.CheckSlug();
    this.slug = this.route.snapshot.params.slug;
    this.membership = this.slug;
    
    // Set default filter option
    this.selectedFilterOption = this.filterOptions[0];
 
  }
    // search function
onSearchInput(event: any) {
  const value = event.target.value?.toLowerCase().trim();
  this.searching = !!value;

  if (value) {
    this.flatData = this.fullFlatData.filter(item =>
      Object.keys(item).some(key => {
        const field = item[key];
        if (typeof field === 'string') {
          return field.toLowerCase().includes(value);
        }
        if (typeof field === 'number') {
          return field.toString() === value;
        }
        return false; 
      })
    );
  } else {
    this.flatData = [...this.fullFlatData];
  }

  console.log(this.flatData);
}

  // function for checking slug and call api according slug
  async CheckSlug() {
    let membership_name = {
      membership_name: '',
    };
    switch (this.route.snapshot.params.slug) {
      case 'Hwm':
        membership_name.membership_name = 'HWM Member';
        this.breadcrumb[0].title = 'HWM Renewal Reports';
        this.spinner.show();
        await this.api_service.gethwmmemberdata(membership_name).then(
          (res: any) => {
            console.log(res);
            
            this.list = res?.data;
            this.fullFlatData = [...res?.data]; // save this for future filters
            this.flatData = [...this.fullFlatData]; 
            console.log(this.flatData,"cjwl");
            
            const filterPipe = new GroupByPipePipe();
            this.renewalHistory = filterPipe.transform(
              res?.data,
              'membership_year'
            );
            this.yearsOfRenewal=[]
            this.yearsOfRenewal=this.renewalHistory
            console.log(this.renewalHistory,"cjcked");
            
            this.spinner.hide();
          },
          (err: any) => {
            console.log(err);
          }
        );

        break;
      case 'Regular':
        membership_name.membership_name = 'Regular Member';
        this.breadcrumb[0].title = 'Regular Renewal Reports';
        this.spinner.show();
        await this.api_service.getMemberRenewalHistory(membership_name).then(
          (res: any) => {
            console.log(res);
            this.list = res?.data;
            this.fullFlatData = [...res?.data]; // save this for future filters
            this.flatData = [...this.fullFlatData]; 
            const filterPipe = new GroupByPipePipe();
             console.log(this.flatData,"cjwl");
            this.renewalHistory = filterPipe.transform(
              res?.data,
              'membership_year'
            );
            this.yearsOfRenewal=[]
            this.yearsOfRenewal=this.renewalHistory
            console.log(this.renewalHistory);
            this.spinner.hide();
          },
          (err: any) => {
            console.log(err);
          }
        );

        break;
      case 'hwm-work-que':
        this.hasmember = 'hwm-work-que';
        console.log(this.breadcrumb)
        this.breadcrumb[0].title = 'HWM Work Que Reports';
        this.spinner.show();
        await this.api_service.getHwmWork().then(
          (res: any) => {
            // console.log(res)
            this.list = res?.data;
            const filterPipe = new GroupByPipePipe();
            this.memberdata = res?.data;
            this.spinner.hide();
          },
          (err: any) => {
            console.log(err);
          }
        );
        break;
      case 'membership-approved':
        this.hasmember = 'membership-approved';
        this.breadcrumb[0].title = 'New Membership Approved Reports'
        //  this.spinner.show();

        // let date = {
        //     from: this.from,
        // to: this.to
        // }

        // await this.api_service.getApprovedHwmMember(date).then((res: any) => {
        //     // console.log(res)
        //     this.list = res?.data
        //     const filterPipe = new GroupByPipePipe();
        //     this.memberdata = res?.data;
        //     this.spinner.hide();
        // },
        //     (err: any) => {
        //         console.log(err);
        //     })
        break;
      case 'membership-status':
        this.hasmember = 'membership-status';
        this.breadcrumb[0].title = 'Membership Status Reports'
        break;
      case 'hwm-renewal-fee':
        this.hasmember = 'hwm-renewal-fee';
        break;
      case 'voter-list':
        this.hasmember = 'voter-list';
        this.breadcrumb[0].title = 'Eligible Voter List Reports'
        break;

      case 'member-data':
        this.hasmember = 'member-data';
        this.breadcrumb[0].title = 'Member Data Reports'
        break;
    }
  }


onEnterSearch() {
  console.log("Called");
  
  const id = this.memberid?.trim();
  console.log(id);
  
  if (id) {
    this.GetMembershipById(id); // call a new function with ID
  }
}
GetMembershipById(id: string) {
  this.spinner.show(); // optional loading indicator
  this.api_service.getmemberdatabyid(id).then(
    (res: any) => {
      console.log('Fetched member:', res);
      this.memeberdatabyid=[res.data];
      ;
      
      console.log(this.memeberdatabyid);
      this.status = true;
      this.spinner.hide();
    },
    (err: any) => {
      console.error('Error fetching member:', err);
      this.spinner.hide();
    }
  );
}
  async GetMembership(event: any, string: any) {
    this.list = [];
      this.from = moment(this.rangeDates[0]).format('YYYY-MM-DD');
      this.to = moment(this.rangeDates[1]).format('YYYY-MM-DD');    
   
    console.log(this.to, this.from, this.rangeDates);
    if (this.to != "Invalid date") {
      this.calendar.overlayVisible = false;
      // this.customerReport["rangeDates"] = this.rangeDates;
      // this.getFormValue.emit(this.rfqList);       
    }   

   
    this.spinner.show();
    let date = {
      from: this.to,
      to: this.from,
    };
    console.log(this.rangeDates)
    if (string === 'getApprovedHwmMember'){
        await this.api_service.getApprovedHwmMember(date).then(
            (res: any) => {
              console.log(res);
              this.list = res?.data;
              const filterPipe = new GroupByPipePipe();
             this.totalData = [res?.data];
              this.memberdata = res?.data?.member_data;
              console.log(this.memberdata);
              console.log(this.renewalHistory);
              this.spinner.hide();
              this.status = true;
            },
            (err: any) => {
              console.log(err);
            }
          );
    }else if(string === 'member-data'){
      let dateto = {
        from: this.from,
        to: this.to,
      };
        await this.api_service.getMemberData(dateto).then(
            (res: any) => {
              console.log(res);
              this.list = res?.data;
              this.status = true;
              const filterPipe = new GroupByPipePipe();
              this.totalData.push(res?.data);
              this.memberdata = res?.data;
              console.log(this.memberdata);
              console.log(this.renewalHistory);
              this.spinner.hide();
            },
            (err: any) => {
              console.log(err);
            }
          );
    }
     
  }
  changeEvent(event: any, string: any) {
    this.totalData = [];
    this.year=event.value
    let object = {
      year: event.value,
    };
    if (string === 'voter-list') {
      this.spinner.show();

      this.api_service.getvoterlist(object).then(
        (res: any) => {
          this.status = true;
          console.log(res);
          this.list = res?.data;
          const filterPipe = new GroupByPipePipe();
          this.memberdata = res?.data;
          console.log(this.memberdata);
          console.log(this.renewalHistory);
          this.spinner.hide();
           
        },
        (err: any) => {
          console.log(err);
        }
      );
    } else if (string === 'membership-status') {
      this.api_service.getMebershipStatus(object).then(
        (res: any) => {
          // console.log(res)
          // this.list = res?.data
          this.status = true;
          const filterPipe = new GroupByPipePipe();
          this.memberdata = res?.data;
          this.totalData.push(res?.data);
          this.list = this.totalData
          console.log('totalData', this.totalData);
          this.spinner.hide();
        },
        (err: any) => {
          console.log(err);
        }
      );
    }
  }
  groupByData: any = [];
  getStringName(event: any, value: any) {
    console.log(event, value);
    this.totalAmount = null;
    this.renewalHistory.map((renewal) => {
      if (renewal?.key == value) {
        this.groupByData = renewal.value;
        this.Datalength = this.groupByData.length;
        this.groupByData.map((item) => {
          this.totalAmount += Math.trunc(item.amount);
          // if (event.index == 0) {
          // }
        });
        console.log(this.groupByData, this.totalAmount);

      }
    });
  }
  reset(dt) {
    dt.reset();
    this.filterVal = '';
  }
  reset1(){
    this.searchbox=''
  //  this.globalTable.reset();
  this.dataTable.reset();            
  }
  resetmembertable(){
    this.memberid=''
  }
  getData(event) {
    console.log(event);
    this.totalAmount = null;
    console.log(this.renewalHistory,"chcked data");
    
    this.renewalHistory.map((renewal) => {
      if (renewal?.key == event) {
        // this.groupByData = renewal.value;
        this.groupByData = renewal.value.filter(item => item.status === 'Approved');
        this.Datalength = this.groupByData.length;
        this.groupByData.map((item) => {
          this.totalAmount += Math.trunc(item.amount);
        });
        console.log(this.groupByData, this.totalAmount);

    
      }
    });
  }
 addSectionVertically(
  title: string,
  headers: string[],
  rows: any[],
  dataArray: any[]
) {
  // Add section title
  dataArray.push({ A: title });

  // Add header row
  const headerRow: any = {};
  headers.forEach((header, idx) => {
    const col = String.fromCharCode(65 + idx); // A, B, C...
    headerRow[col] = header;
  });
  dataArray.push(headerRow);

  // Add data rows
  rows.forEach(row => {
    const dataRow: any = {};
    headers.forEach((header, idx) => {
      const col = String.fromCharCode(65 + idx);
      dataRow[col] = row[header] || '';
    });
    dataArray.push(dataRow);
  });

  // Add a blank row
  dataArray.push({});
}

//make a dropdown for export functionality for renewal data 
exportRenewalDropDownData(): void {
  console.log('Export button clicked with filter:', this.selectedFilterOption);

  if (!this.selectedFilterOption) {
    console.warn('No filter option selected. Please select a filter option first.');
    return;
  }

  switch (this.selectedFilterOption) {
    case 'waste_disposed_with_manifest':
      this.exportRenewalDataToExcel();
      break;

    case 'waste_disposed_without_manifest':
      this.exportRenewalDataWithoutManifestToExcel();
      break;

    case 'active_with_ucci':
      this.getMemberMembershipsGroupedbystatus();
      break;

    default:
      console.warn('Unknown filter option:', this.selectedFilterOption);
  }
}

  onFilterChange(event: any) {
    console.log('Filter changed to:', event.value);
    console.log('Selected filter option object:', this.selectedFilterOption);
    // You can add additional logic here if needed when filter changes
  }

async exportRenewalDataToExcel() {
  try {
    this.spinner.show();
    
    // Fetch renewal data from API - you can use either endpoint
    let renewalData;
    try {
      // Try the new specific endpoint first
      renewalData = await this.api_service.getRenewalCompaniesWithManifest();
    } catch (error) {
      // Fallback to the existing endpoint
      renewalData = await this.api_service.anaylzeddata({ membership_name: 'Hwm Member' });
    }
    
    const tableData = [];
    
    // Get all year keys from the API response
    const yearKeys = Object.keys(renewalData).filter(key => key.startsWith('year') && key !== 'summary');
    console.log('Available year keys:', yearKeys);
    
    // ------------------------------
    // Create individual sheets for ALL years
    // ------------------------------
    for (let i = 0; i < 20; i++) { // Check up to year 20 to be safe
      const yearKey = `year${i}_pending_renewal`;
      if (renewalData[yearKey] && renewalData[yearKey].length > 0) {
        const yearData = renewalData[yearKey].map((item: any, index: number) => ({
          'Sr No': index + 1,
          'Member ID': item.member_id || '-',
          'Company Name': item.company_name || '-',
          'Membership No': item.membership_no || '-',
          'Nominee 1 Name': item.nominee1_name || '-',
          'Nominee 2 Name': item.nominee2_name || '-',
          'Total Pending Years': item.total_pending_years || 0,
          'Pending Years': item.pending_years ? item.pending_years.join(', ') : '-',
          'Has 2025-2026': item.has_2025_2026 ? 'Yes' : 'No'
        }));

        const sheetName = i === 0 ? 'Year 0 - No Pending' : `Year ${i} - Pending`;
        tableData.push({
          data: yearData,
          name: sheetName
        });
      }
    }

    // ------------------------------
    // Summary Report - Dynamic based on available data
    // ------------------------------
    if (renewalData.summary) {
      const summaryData = [];
      
      // Add summary for each available year
      for (let i = 0; i < 20; i++) { // Check up to year 20
        const yearCountKey = `year${i}_count`;
        if (renewalData.summary[yearCountKey] !== undefined) {
          summaryData.push({
            'Category': i === 0 ? 'Year 0 - No Pending' : `Year ${i} - Pending`,
            'Count': renewalData.summary[yearCountKey] || 0,
            'Description': i === 0 ? 'Companies with no pending renewal years' : `Companies with ${i} year${i > 1 ? 's' : ''} pending renewal`
          });
        }
      }

      // Add total summaries if available
      if (renewalData.summary.total_companies_with_pending !== undefined) {
        summaryData.push({
          'Category': 'Total Companies with Pending',
          'Count': renewalData.summary.total_companies_with_pending || 0,
          'Description': 'Total companies having pending renewals'
        });
      }

      if (renewalData.summary.total_companies_no_pending !== undefined) {
        summaryData.push({
          'Category': 'Total Companies No Pending',
          'Count': renewalData.summary.total_companies_no_pending || 0,
          'Description': 'Total companies with no pending renewals'
        });
      }

      if (renewalData.summary.grand_total_companies !== undefined) {
        summaryData.push({
          'Category': 'Grand Total Companies',
          'Count': renewalData.summary.grand_total_companies || 0,
          'Description': 'Total number of companies'
        });
      }

      if (summaryData.length > 0) {
        tableData.push({
          data: summaryData,
          name: 'Summary Report'
        });
      }
    }

    // ------------------------------
    // Export all Sheets
    // ------------------------------
    this.api_service.exportMultipleExcel(
      tableData,
      this.rangeDates,
      'Renewal Companies with Manifest Report'
    );

    this.spinner.hide();
  } catch (error) {
    console.error('Error exporting renewal data:', error);
    this.spinner.hide();
  }
}

async exportRenewalDataWithoutManifestToExcel() {
  try {
    this.spinner.show();
    
    // Fetch renewal data from API for companies without manifest
    let renewalData;
    try {
      renewalData = await this.api_service.getRenewalCompaniesWithoutManifest();
    } catch (error) {
      console.error('Error fetching renewal data without manifest:', error);
      this.spinner.hide();
      return;
    }
    
    const tableData = [];
    
    // Get all year keys from the API response
    const yearKeys = Object.keys(renewalData).filter(key => key.startsWith('year') && key !== 'summary');
    console.log('Available year keys for without manifest:', yearKeys);
    
    // ------------------------------
    // Create individual sheets for ALL years
    // ------------------------------
    for (let i = 0; i < 20; i++) { // Check up to year 20 to be safe
      const yearKey = `year${i}_pending_renewal`;
      if (renewalData[yearKey] && renewalData[yearKey].length > 0) {
        const yearData = renewalData[yearKey].map((item: any, index: number) => ({
          'Sr No': index + 1,
          'Member ID': item.member_id || '-',
          'Company Name': item.company_name || '-',
          'Membership No': item.membership_no || '-',
          'Nominee 1 Name': item.nominee1_name || '-',
          'Nominee 2 Name': item.nominee2_name || '-',
          'Total Pending Years': item.total_pending_years || 0,
          'Pending Years': item.pending_years ? item.pending_years.join(', ') : '-',
          'Has 2025-2026': item.has_2025_2026 ? 'Yes' : 'No',
          'Manifest Status': 'No Manifest'
        }));

        const sheetName = i === 0 ? 'Year 0 - No Pending' : `Year ${i} - Pending`;
        tableData.push({
          data: yearData,
          name: sheetName
        });
      }
    }

    // ------------------------------
    // Summary Report - Dynamic based on available data
    // ------------------------------
    if (renewalData.summary) {
      const summaryData = [];
      
      // Add summary for each available year
      for (let i = 0; i < 20; i++) { // Check up to year 20
        const yearCountKey = `year${i}_count`;
        if (renewalData.summary[yearCountKey] !== undefined) {
          summaryData.push({
            'Category': i === 0 ? 'Year 0 - No Pending' : `Year ${i} - Pending`,
            'Count': renewalData.summary[yearCountKey] || 0,
            'Description': i === 0 ? 'Companies with no pending renewal years and no manifest' : `Companies with ${i} year${i > 1 ? 's' : ''} pending renewal and no manifest`
          });
        }
      }

      // Add total summaries if available
      if (renewalData.summary.total_companies_with_pending !== undefined) {
        summaryData.push({
          'Category': 'Total Companies with Pending (No Manifest)',
          'Count': renewalData.summary.total_companies_with_pending || 0,
          'Description': 'Total companies having pending renewals without manifest'
        });
      }

      if (renewalData.summary.total_companies_no_pending !== undefined) {
        summaryData.push({
          'Category': 'Total Companies No Pending (No Manifest)',
          'Count': renewalData.summary.total_companies_no_pending || 0,
          'Description': 'Total companies with no pending renewals and no manifest'
        });
      }

      if (renewalData.summary.grand_total_companies !== undefined) {
        summaryData.push({
          'Category': 'Grand Total Companies (No Manifest)',
          'Count': renewalData.summary.grand_total_companies || 0,
          'Description': 'Total number of companies without manifest'
        });
      }

      if (summaryData.length > 0) {
        tableData.push({
          data: summaryData,
          name: 'Summary Report'
        });
      }
    }

    // ------------------------------
    // Export all Sheets
    // ------------------------------
    this.api_service.exportMultipleExcel(
      tableData,
      this.rangeDates,
      'Renewal Companies without Manifest Report'
    );

    this.spinner.hide();
  } catch (error) {
    console.error('Error exporting renewal data without manifest:', error);
    this.spinner.hide();
  }
}

//get-member-memberships-grouped-by-status
async getMemberMembershipsGroupedbystatus() {
  try {
    this.spinner.show();
    
    // Fetch grouped membership data from API
    let groupedData:any;
    try {
      groupedData = await this.api_service.getActiveWithUcci();
    } catch (error) {
      console.error('Error fetching grouped membership data:', error);
      this.spinner.hide();
      return;
    }
    this.groupedData = groupedData;
    this.statusKeys = Object.keys(groupedData);

    const tableData = [];
    // Loop through each status key and create a sheet for each
    this.statusKeys.forEach((statusKey) => {
      const details = groupedData[statusKey];
      if (Array.isArray(details) && details.length > 0) {
        const statusData = details.map((item: any, index: number) => ({
          'Sr No': index + 1,
          'Membership No': item.membership_no || '-',
          'Company Name': item.company_name || '-',
          'Nominee 1 Name': item.nominee1_name || '-',
          'Nominee 1 Email': item.nominee1_email || '-',
          'Nominee 1 Mobile': item.nominee1_mobile || '-',
          'Nominee 2 Name': item.nominee2_name || '-',
          'Nominee 2 Email': item.nominee2_email || '-',
          'Nominee 2 Mobile': item.nominee2_mobile || '-',
          'Status': statusKey,
          // Add more fields as needed based on your data structure
        }));
        tableData.push({
          data: statusData,
          name: statusKey
        });
      }
    });
    // Export all Sheets (one per status)
    this.api_service.exportMultipleExcel(
      tableData,
      this.rangeDates,
      'Memberships Grouped by Status Report'
    );
    this.spinner.hide();
  } catch (error) {
    console.error('Error exporting grouped membership data:', error);
    this.spinner.hide();
  }
}


async exportRegularMembership() {
 const tableData = [];
const membershipData = this.flatData;

// ------------------------------
// Section: Membership Details
// ------------------------------
const formattedMembershipData = membershipData.map((data, index) => {
  let approvedWaste = '-';
  let wasteSummary = '-';

  try {
    const parsedManifest = data?.uploaded_manifest_details
      ? JSON.parse(data.uploaded_manifest_details)
      : [];

    if (parsedManifest.length > 0) {
      approvedWaste = parsedManifest.map((item, i) =>
        `#${i + 1}: Schedule ${item.schedule_no}, Process ${item.waste_process_no || '-'}`
        + `.${item.waste_sub_process_no || '-'}, Type: ${item.waste_type || '-'}, `
        + `Quantity: ${item.waste_quantity || '-'}`
      ).join('; ');
    }
  } catch (e) {
    console.warn('Invalid uploaded_manifest_details for index', index);
  }

  try {
    const parsedSummary = data?.waste_summary
      ? JSON.parse(data.waste_summary)
      : [];

    if (parsedSummary.length > 0) {
      wasteSummary = parsedSummary.map((item, i) =>
        `#${i + 1}: ${item.type_of_waste || '-'} - ${item.quantity_of_waste || '-'}-${item.category_no || '-'}`
      ).join('; ');
    }
  } catch (e) {
    // console.warn('Invalid waste_summary for index', index);
  }

  return {
    'Sr No': index + 1,
    'Company Name': data.company_name || '-',
    'Membership No': data.membership_no || '-',
    'Membership_status': data.status || '-', 
    'HWM Owner Name': data.nominee1_name || '-',
    'HWM Owner Email': data.nominee1_email || '-',
    'HWM Owner Mobile': data.nominee1_mobile || '-',
    'HWM Contact Person Name': data.nominee2_name || '-',
    'HWM Contact Person Email': data.nominee2_email || '-',
    'HWM Contact Person Mobile': data.nominee2_mobile || '-',
    'Renewal Pending (Years)': data.renewal_pending_years || '-',
    'Waste Disposal Status': data.waste_disposal_status || '-',
    'Approved Waste Details as per Membership Letter': approvedWaste,
    'Details of Waste Disposed': wasteSummary,
  };
});


tableData.push({
  data: formattedMembershipData,
  name: 'Membership Details'
});
  // ------------------------------
  // Section: Data Analysis (Summary Report)
  // ------------------------------

const dataAnalysis = [];

try {
  const renewalData = await this.api_service.anaylzeddata({ membership_name: 'Hwm Member' });

  // --- Section 1: Waste Disposal Summary ---
  const wasteData = Object.entries(renewalData.waste_disposal_summary).map(([key, value]) => {
    return {
      'Waste Disposal Category': key,
      'Count of membership_no': value === 0 ? '0' : value
    };
  });

  this.addSectionVertically(
    'Section 1: Laste Dis Status',
    ['Waste Disposal Category', 'Count of membership_no'],
    wasteData,
    dataAnalysis
  );

  // --- Section 2: Membership Status Summary ---
  const statusData = [];
  const summary = renewalData.membership_status_summary;

  Object.keys(summary).forEach(key => {
    const value = summary[key];
    if (typeof value === 'object' && value !== null && 'status_category' in value && 'member_count' in value) {
      // Already in desired format
      statusData.push({
        status_category: value.status_category,
        member_count: value.member_count
      });
    } else {
      // For keys like "Not Applicable" or "Grand Total"
      statusData.push({
        status_category: key,
        member_count: value
      });
    }
  });

  // Map to use the exact header names as keys
  const statusDataForExport = statusData.map(item => ({
    'Membership Status': item.status_category,
    'Count of Membership No': item.member_count
  }));

  this.addSectionVertically(
    'Section 2: Membership Status',
    ['Membership Status', 'Count of Membership No'],
    statusDataForExport,
    dataAnalysis
  );
    // --- Section 3: Membership Status Summary ---
  const Wastedata = Object.entries(renewalData.renewal_pending_summary).map(([key, value]) => {
    return {
      'Renewal pending - years': key,
      'Count of membership_no': value === 0 ? '0' : value
    };
  });

  this.addSectionVertically(
    'Section 3: Renewal pending',
    ['Renewal pending - years', 'Count of membership_no'],
    Wastedata,
    dataAnalysis
  );
    // --- Section 4: Membership Status Summary ---
  const notdisposed = Object.entries(renewalData.renewal_pending_with_manifest).map(([key, value]) => {
    return {
      'Renewal pending - years': key,
      'Count of membership_no': value === 0 ? '0' : value
    };
  });

  this.addSectionVertically(
    'Section 4: Waste Disposal Status Active in last 4 year',
    ['Renewal pending - years', 'Count of membership_no'],
    notdisposed,
    dataAnalysis
  );
   // --- Section 5: Membership Status Summary ---
  const renewalpending = Object.entries(renewalData.renewal_pending_without_manifest).map(([key, value]) => {
    return {
      'Renewal pending - years': key,
      'Count of membership_no': value === 0 ? '0' : value
    };
  });

  this.addSectionVertically(
    'Section 5: Waste not disposed since membership was grant',
    ['Renewal pending - years', 'Count of membership_no'],
    renewalpending,
    dataAnalysis
  );
} catch (error) {
  console.error('Error fetching or processing data summary:', error);
}


// Push final table
console.log(dataAnalysis);
tableData.push({
  name: 'Data Analysis',
  data: dataAnalysis
});


  // ------------------------------
  // Section: Renewal Amount Year Wise
  // ------------------------------
 try {
    const renewalData = await this.api_service.renewalamount({ membership_name: 'Hwm Member' });
    const emailFailureData =renewalData.data.map((data, index) => ({
      'Sr No': index + 1,
      'Financial Year': data.financial_year || '-',
      'Expected Renewal Fee (A) (INR)': data.expected_renewal_fee || '-',
      'Dues from the previous FY (B) (INR)': data.dues_from_previous_fy || '-',
      'Total Dues (A+B) (INR)': data.total_dues || '-',
      'Amount received against Renewal Fee (INR) as on date':data.received_amount|| '',
      'Total Dues':data.total_dues|| ''
    }));

    tableData.push({
      data: emailFailureData,
      name: 'Renewal Amount Year Wise'
    });
  } catch (error) {
    console.error('Error fetching renewal amount:', error);
  }

  // ------------------------------
  // Export all Sheets
  // ------------------------------
  this.api_service.exportMultipleExcel(
    tableData,
    this.rangeDates,
    'Membership Renewal Full Report'
  );
}

  // XLS Export Function
  onXLSExport() {
    console.log(this.slug)
    console.log(this.flatData)
    this.excelData = [];
    this.filteredXLSData = [];
    if ( this.slug == 'Regular') {
      if (this.dataTable.filteredValue != null) {
        this.filteredXLSData = this.dataTable.filteredValue;
      } else if (this.dataTable.filteredValue == null) {
        this.filteredXLSData = this.list;
      }
    
      const cols = [
        { field: 'sr_no', header: 'Sr No' },
        { field: 'company_name', header: 'Company Name' },
        { field: 'membership_no', header: 'Membership No' },
        { field: `nominee1_name`, header: `Nominee Name 1 ` },
        { field: `nominee1_email`, header: `Nominee Email 1` },
        { field: `nominee1_mobile`, header: `Nominee Contact 1` },    
        { field: `nominee2_name`, header: `Nominee Name 2 ` },
        { field: `nominee2_email`, header: `Nominee Email 2` },
        { field: `nominee2_mobile`, header: `Nominee Contact 2` },        
      ];
    
      this.yearsOfRenewal.forEach(item => {
        let years = item.key.match(/\d{4}/g);
        if (years && years.length === 2) {
          let startYear = years[0];
          let endYear = years[1];
          cols.push({ field: `Renewal List ${startYear}-${endYear}`, header: `${startYear}-${endYear.slice(2)}` });
        }
      });
      cols.push({ field: `total`, header: `Total` });
      let index = 1;
      for (let i = 0; i < this.filteredXLSData.length; i++) {
        let rowData = {};
        if ((this.filteredXLSData[i].status == "Approved" || this.filteredXLSData[i].status == "Terminated") || (this.filteredXLSData[i].status == "Provisionally Terminated")) {
          let total = 0;
          cols.forEach(col => {
            if (col.field === 'sr_no') {          
              rowData[col.field] = index++;
            } else if (col.field === this.filteredXLSData[i].membership_year) {
              let headerYears = this.extractYear(col.field);
              let fieldYears = this.extractYear(this.filteredXLSData[i].membership_year);
              if (headerYears == fieldYears) {
                if (typeof parseFloat(this.filteredXLSData[i]?.amount) === 'number' && !isNaN(this.filteredXLSData[i]?.amount)) {
                  total += parseFloat(this.filteredXLSData[i]?.amount);
                }
                rowData[col.field] = this.filteredXLSData[i]?.amount || null;
              } 
            } else if (col.field === 'company_name' || col.field === 'membership_no' || col.field === 'nominee2_name' || col.field === 'nominee2_email' || col.field === 'nominee2_mobile'|| col.field === 'nominee1_name' || col.field === 'nominee1_email' || col.field === 'nominee1_mobile') {
              rowData[col.field] = this.filteredXLSData[i]?.[col.field] || null;
            } else if (col.field == 'total') {
              rowData[col.field] = total;
            } else { 
              this.duplicateMember = this.extractYear(col.field, this.filteredXLSData[i]);
              rowData[col.field] = this.duplicateMember?.amount ? this.duplicateMember?.amount : null;
              
              if (typeof parseFloat(this.duplicateMember?.amount) === 'number' && !isNaN(this.duplicateMember?.amount)) {
                total += parseFloat(this.duplicateMember?.amount);
              }
            }      
          });
          this.excelData.push(rowData);
        }
      }

      // on 14th April @025 
      // there is change in renewal excel where we remove Terminated and Provisionally Terminated status from excel because in backend we not send terminated and provisionally terminated status
      
      // let index2 = 1;
      // this.excelData2 = [];
      
      // for (let i = 0; i < this.filteredXLSData.length; i++) {
      //     let rowData = {};
      //     if (this.filteredXLSData[i].status == "Approved") {
      //         let total = 0;
      //         cols.forEach(col => {
      //             if (col.field === 'sr_no') {          
      //                 rowData[col.field] = index2++;
      //             } else if (col.field === this.filteredXLSData[i].membership_year) {
      //                 let headerYears = this.extractYear(col.field);
      //                 let fieldYears = this.extractYear(this.filteredXLSData[i].membership_year);
      //                 if (headerYears == fieldYears) {
      //                     if (typeof parseFloat(this.filteredXLSData[i]?.amount) === 'number' && !isNaN(this.filteredXLSData[i]?.amount)) {
      //                         total += parseFloat(this.filteredXLSData[i]?.amount);
      //                     }
      //                     rowData[col.field] = this.filteredXLSData[i]?.amount || null;
      //                 } 
      //             } else if (col.field === 'company_name' || col.field === 'membership_no') {
      //                 rowData[col.field] = this.filteredXLSData[i]?.[col.field] || null;
      //             } else if (col.field == 'total') {
      //                 rowData[col.field] = total;
      //             } else { 
      //                 this.duplicateMember = this.extractYear(col.field, this.filteredXLSData[i]);
      //                 rowData[col.field] = this.duplicateMember?.amount ? this.duplicateMember?.amount : null;
                      
      //                 if (typeof parseFloat(this.duplicateMember?.amount) === 'number' && !isNaN(this.duplicateMember?.amount)) {
      //                     total += parseFloat(this.duplicateMember?.amount);
      //                 }
      //             }      
      //         });
      //         this.excelData2.push(rowData);
      //     }
      // }



      // let index3 = 1;
      // this.excelData3 = [];
      
      // for (let i = 0; i < this.filteredXLSData.length; i++) {
      //     let rowData = {};
      //     if (this.filteredXLSData[i].status == "Provisionally Terminated") {
      //         let total = 0;
      //         cols.forEach(col => {
      //             if (col.field === 'sr_no') {          
      //                 rowData[col.field] = index3++;
      //             } else if (col.field === this.filteredXLSData[i].membership_year) {
      //                 let headerYears = this.extractYear(col.field);
      //                 let fieldYears = this.extractYear(this.filteredXLSData[i].membership_year);
      //                 if (headerYears == fieldYears) {
      //                     if (typeof parseFloat(this.filteredXLSData[i]?.amount) === 'number' && !isNaN(this.filteredXLSData[i]?.amount)) {
      //                         total += parseFloat(this.filteredXLSData[i]?.amount);
      //                     }
      //                     rowData[col.field] = this.filteredXLSData[i]?.amount || null;
      //                 } 
      //             } else if (col.field === 'company_name' || col.field === 'membership_no') {
      //                 rowData[col.field] = this.filteredXLSData[i]?.[col.field] || null;
      //             } else if (col.field == 'total') {
      //                 rowData[col.field] = total;
      //             } else { 
      //                 this.duplicateMember = this.extractYear(col.field, this.filteredXLSData[i]);
      //                 rowData[col.field] = this.duplicateMember?.amount ? this.duplicateMember?.amount : null;
                      
      //                 if (typeof parseFloat(this.duplicateMember?.amount) === 'number' && !isNaN(this.duplicateMember?.amount)) {
      //                     total += parseFloat(this.duplicateMember?.amount);
      //                 }
      //             }      
      //         });
      //         this.excelData3.push(rowData);
      //     }
      // }



      // let index4 = 1;
      // this.excelData4 = [];
      
      // for (let i = 0; i < this.filteredXLSData.length; i++) {
      //     let rowData = {};
      //     if (this.filteredXLSData[i].status == "Terminated") {
      //         let total = 0;
      //         cols.forEach(col => {
      //             if (col.field === 'sr_no') {          
      //                 rowData[col.field] = index4++;
      //             } else if (col.field === this.filteredXLSData[i].membership_year) {
      //                 let headerYears = this.extractYear(col.field);
      //                 let fieldYears = this.extractYear(this.filteredXLSData[i].membership_year);
      //                 if (headerYears == fieldYears) {
      //                     if (typeof parseFloat(this.filteredXLSData[i]?.amount) === 'number' && !isNaN(this.filteredXLSData[i]?.amount)) {
      //                         total += parseFloat(this.filteredXLSData[i]?.amount);
      //                     }
      //                     rowData[col.field] = this.filteredXLSData[i]?.amount || null;
      //                 } 
      //             } else if (col.field === 'company_name' || col.field === 'membership_no') {
      //                 rowData[col.field] = this.filteredXLSData[i]?.[col.field] || null;
      //             } else if (col.field == 'total') {
      //                 rowData[col.field] = total;
      //             } else { 
      //                 this.duplicateMember = this.extractYear(col.field, this.filteredXLSData[i]);
      //                 rowData[col.field] = this.duplicateMember?.amount ? this.duplicateMember?.amount : null;
                      
      //                 if (typeof parseFloat(this.duplicateMember?.amount) === 'number' && !isNaN(this.duplicateMember?.amount)) {
      //                     total += parseFloat(this.duplicateMember?.amount);
      //                 }
      //             }      
      //         });
      //         this.excelData4.push(rowData);
      //     }
      // }
      
      let exportColumns = cols.map((col) => ({
        title: col.header,
        dataKey: col.field,
      }));
    
     
      let seenMembershipNumbers: { [key: number]: boolean } = {};

      this.excelData = this.excelData.filter(obj => {
        if (!seenMembershipNumbers[obj.membership_no]) {
            seenMembershipNumbers[obj.membership_no] = true;
            return true; // Keep the object
        }
        return false; // Discard the object
        
    });
    // seenMembershipNumbers = {};
    // this.excelData2 = this.excelData2.filter(obj => {
    //   if (!seenMembershipNumbers[obj.membership_no]) {
    //       seenMembershipNumbers[obj.membership_no] = true;
    //       return true; // Keep the object
    //   }
    //   return false; // Discard the object
    // });
    // seenMembershipNumbers = {};
    // this.excelData3 = this.excelData3.filter(obj => {
    //   if (!seenMembershipNumbers[obj.membership_no]) {
    //       seenMembershipNumbers[obj.membership_no] = true;
    //       return true; // Keep the object
    //   }
    //   return false; // Discard the object
    // });
    // seenMembershipNumbers = {};
    // this.excelData4 = this.excelData4.filter(obj => {
    //   if (!seenMembershipNumbers[obj.membership_no]) {
    //       seenMembershipNumbers[obj.membership_no] = true;
    //       return true; // Keep the object
    //   }
    //   return false; // Discard the object
    // });

    let indexs1 = 1;
    this.excelData.forEach(obj => {
        obj.sr_no = indexs1++;
    });
    // let indexs2 = 1;
    // this.excelData2.forEach(obj => {
    //     obj.sr_no = indexs2++;
    // });

    // let indexs3 = 1;
    // this.excelData3.forEach(obj => {
    //     obj.sr_no = indexs2++;
    // });

    // let indexs4 = 1;
    // this.excelData4.forEach(obj => {
    //     obj.sr_no = indexs4++;
    // });
      this.api_service.exportMultipleExcelForRenewal(
        this.excelData,
        // this.excelData2,
        // this.excelData3,
        // this.excelData4,
        this.route.snapshot.params.slug == 'Hwm' ? 'HWM-Membership-Renewal-Report' : 'Regular-Membership-Renewal-Report',
      );
    }
    else if(this.slug == 'Hwm'){
     this.exportRegularMembership();
    }
    
  //  else if(this.slug == 'membership-approved'){
  //   const data = this.list;
  //   this.filteredXLSData = data.member_data
  // }
 else if (this.slug === 'membership-approved') {
  const combinedData = [];

  // Add main member data
  const memberData = this.list?.member_data || [];
  memberData.forEach((data, index) => {
    combinedData.push({
      'Sr No': index + 1,
      'Company Name': data.company_name || '-',
      'Membership No': data.membership_no || '-',
      'Place': data.city || '-',
      'Amount': data.amount || '-',
      'Status': data.status || '-',
      'Created at': data.created_at || '-',
      'Updated at': data.updated_at || '-'
    });
  });

  
  combinedData.push({}); 

  combinedData.push(
    {
      'Sr No': '',
      'Company Name': 'Total Amount Received',
      'Membership No': this.list?.total_amount || '-',
      'Place': '',
      'Amount': '',
      'Status': '',
    },
    {
      'Sr No': '',
      'Company Name': '20% Amount To Be Retained By UCCI',
      'Membership No': this.list?.retained_amount || '-',
      'Place': '',
      'Amount': '',
      'Status': '',
    },
    {
      'Sr No': '',
      'Company Name': 'Balance Amount Payable To ReSL',
      'Membership No': this.list?.balance_amount || '-',
      'Place': '',
      'Amount': '',
      'Status': '',
    }
  );

  // Now pass it to single-sheet export
  this.api_service.exportExcel(
    combinedData,
    'Membership Approved Report',
    this.rangeDates
  );
}

  else if(this.slug == 'voter-list'){
   
    // const data = this.list;
    //  this.filteredXLSData = data.member_data

    for (let i = 0; i < this.memberdata.length; i++) {
      this.excelData.push({
        'Sr No': i + 1,
        'Membership No': this.memberdata[i]?.membership_no,
        'Company Name': this.memberdata[i]?.company_name,
        'First Nominee': this.memberdata[i]?.nominee1?.name,
        'First Nominee Mobile No.': this.memberdata[i]?.nominee1?.mobile,
        'First Nominee Email': this.memberdata[i]?.nominee1?.email,
        'Second Nominee': this.memberdata[i]?.nominee2?.name,
        'Second Nominee Mobile No.': this.memberdata[i]?.nominee2?.mobile,
        'Second Nominee Email': this.memberdata[i]?.nominee2?.email,
        'Address':this.memberdata[i]?.company_address[i]?.address,
        'City':this.memberdata[i]?.company_address[i]?.city,
        'Grade': this.memberdata[i]?.member_category?.code,
        'Category': this.memberdata[i]?.member_category?.name,
        'Classification': this.memberdata[i]?.member_classification?.name,
        'Code': this.memberdata[i]?.member_classification?.code,
        'Year of joining':this.memberdata[i]?.member_since,     
        'Created at':this.memberdata[i]?.created_at,
        'Updated at':this.memberdata[i]?.updated_at
      });
    }
    this.api_service.exportExcel(
      this.excelData,
      this.route.snapshot.params.slug == 'voter-list'
      ? 'Eligible Voter List Reports'
      : 'Eligible Voter List Reports',
      this.voterYear
    );
     
   
  }
  else if (this.slug == 'membership-status') {
    const tableData = [];

    const memberStatusData = [
      {
        'S. No.': 1,
        Particulars: 'New Memberships',
        'Previous Financial Year':
          this.memberdata?.previous_fn_new_member_count || '-',
        'Current Financial Year':
          this.memberdata?.current_fn_new_member_count || '-',
      },
      {
        'S. No.': 2,
        Particulars: 'Revision in Memberships',
        'Previous Financial Year':
          this.memberdata?.previous_fn_revision_count || '-',
        'Current Financial Year':
          this.memberdata?.current_fn_revision_count || '-',
      },
    ];

    tableData.push({
      data: memberStatusData,
      name: 'Membership Status',
    });

    const financialUpdatesData = [
      {
        'S.No': 1,
        Particulars: 'New Membership Fee',
        Details: `Rs. ${
          this.totalData[0]?.current_fn_new_membership_total_amount.replace(
            '.00',
            ''
          ) || '-'
        }`,
      },
      {
        'S.No': 2,
        Particulars: 'Membership Revision Amount',
        Details: `Rs. ${
          this.totalData[0]?.current_fn_revision_total_amount.replace(
            '.00',
            ''
          ) || '-'
        }`,
      },
      {
        'S.No': 3,
        Particulars: 'Membership Renewal Amount',
        Details: `Rs. ${
          this.totalData[0]?.current_fn_renewal_amt.replace('.00', '') || '-'
        }`,
      },
      {
        'S.No': 4,
        Particulars: 'Trust Development Fee',
        Details: `Rs. ${
          this.totalData[0]?.current_fn_trust_development_total_amount.replace(
            '.00',
            ''
          ) || '-'
        }`,
      },
    ];

    tableData.push({
      data: financialUpdatesData,
      name: 'Financial Updates',
    });

    // Third Table: MEMBERSHIP RENEWAL STATUS
    const membershipRenewalStatusData = [
      {
        'S.No': 1,
        Particulars: 'Total Members',
        Details: this.totalData[0]?.total_members || '-',
      },
      {
        'S.No': 2,
        Particulars: 'Fully Paid',
        Details: this.totalData[0]?.fully_paid || '-',
      },
      {
        'S.No': 3,
        Particulars: 'Due',
        Details: this.totalData[0]?.due || '-',
      },
    ];

    tableData.push({
      data: membershipRenewalStatusData,
      name: 'Membership Renewal Status',
    });
    this.api_service.exportMultipleExcel(
      tableData,
      this.rangeDates,
      'Membership Status Report'
    );
  } 

  else if(this.slug == 'member-data'){
   
    // const data = this.list;
    //  this.filteredXLSData = data.member_data
for (let i = 0; i < this.memeberdatabyid.length; i++) {
  const data = this.memeberdatabyid[i];
  const paymentInvoices = data.payment_invoices || {};

  // Flattening arrays/objects to strings
  const wasteDetailsStr = data?.waste_details
    ? JSON.parse(data.waste_details).map(w => `${w.waste_type} (${w.waste_quantity})`).join('; ')
    : '-';

  const changesStr = data?.member_data_changes
    ? data.member_data_changes.map(change => `Year: ${change.change_year}, Fields: ${change.changed_in}`).join('; ')
    : '-';

const revisionNotesheets = data?.uploaded_documents?.member_data_docs
  ?.map(doc => doc.revision_notesheet
    ? `${this.ucciBaseUrl}/storage/hwm/revision/${doc.revision_notesheet}`
    : null
  )
  .filter(Boolean)
  .join(', ') || '-';

  const invoicesFromDocs = data?.uploaded_documents?.member_data_docs
    ?.map(doc => doc.invoice_pdf? `${this.ucciBaseUrl}/storage/invoices/${doc.revision_notesheet}`:null)
    .filter(Boolean)
    .join(', ') ?? '-';

  const revisionLettersStr = (data?.revision_letters || []).join(', ') || '-';

  const memberDataInvoicesStr = (paymentInvoices?.member_data_invoices || []).join(', ') || '-';

  const membershipInvoicesStr = (paymentInvoices?.membership_invoices || [])
    .map(inv => typeof inv === 'string' ? inv : inv?.invoice_pdf)
    .filter(Boolean)
    .join(', ') || '-';

  let rowData = {
    membership_no: data?.membership_no ?? '-',
    company_name: data?.company_name ?? '-',
    member_since: data?.member_since ?? '-',
    emails: data?.nominees_info?.emails ?? '-',
    nominee1_contact: data?.nominees_info?.nominee1_contact ?? '-',
    factory_address: data?.addresses?.factory_address ?? '-',
    registered_address: data?.addresses?.registered_address ?? '-',
    waste_details: wasteDetailsStr,
    member_data_changes: changesStr,
    revision_notesheets: revisionNotesheets,
    member_data_invoices: memberDataInvoicesStr,
    membership_invoices: membershipInvoicesStr,
    revision_letters: revisionLettersStr,
    documents_uploaded: invoicesFromDocs
  };

  this.excelData.push(rowData);
}


    this.api_service.exportExcel(
      this.excelData,
      'Member Data',
      this.rangeDates
    );
     
   
  }


   else{
    this.filteredXLSData = this.list;
  }
  // this.api_service.exportExcel(
  //   this.filteredXLSData,
  //  'reports',
  //  this.rangeDates
  // );
   // this.route.snapshot.params.slug == 'Hwm'
      //   ? 'HWM-Membership-Renewal-Report'
      //   : 'Regular-Membership-Renewal-Report'
}

  // PDF Export Function
  // onPDFExport() {
  //   this.filteredPDFData = [];
  //   this.pdfData = [];
  //   if (this.dataTable.filteredValue != null) {
  //     this.filteredPDFData = this.dataTable.filteredValue;
  //   } else if (this.dataTable.filteredValue == null) {
  //     this.filteredPDFData = this.list;
  //   }
  //   for (let i = 0; i < this.filteredPDFData.length; i++) {
  //     this.pdfData.push({
  //       sr_no: i + 1,
  //       companyName: this.filteredPDFData[i]?.company_name,
  //       membershipNo: this.filteredPDFData[i]?.membership_no,
  //       amount: this.filteredPDFData[i]?.amount,
  //       membershipYear: this.filteredPDFData[i]?.membership_year,
  //       membershipType: this.filteredPDFData[i]?.membership_name,
  //       email: this.filteredPDFData[i]?.email,
  //       expiringDate: moment(this.filteredPDFData[i]?.expire_at).format(
  //         'DD/MM/YYYY'
  //       ),
  //     });
  //   }
  //   this.api_service.exportPdf(
  //     this.pdfData,
  //     this.exportColumns,
  //     this.route.snapshot.params.slug == 'Hwm'
  //       ? 'HWM-Membership-Renewal-Report'
  //       : 'Regular-Membership-Renewal-Report'
  //   );
  // }

  onPDFExport() {
    this.filteredPDFData = [];
    this.pdfData = [];
  
    if(this.slug == 'Hwm' || this.slug == 'Regular'){
      if (this.dataTable.filteredValue != null) {
        this.filteredPDFData = this.dataTable.filteredValue;

      } else if (this.dataTable.filteredValue == null) {
        this.filteredPDFData = this.list;
      }
       const cols = [
        { field: 'sr_no', header: 'Sr No' },
        { field: 'company_name', header: 'Company Name' },
        { field: 'membership_no', header: 'Membership No' },      
      ];

      this.yearsOfRenewal.forEach(item => {
        let years = item.key.match(/\d{4}/g);
        if (years && years.length === 2) {
          let startYear = years[0];
          let endYear = years[1];
         cols.push({ field: `Renewal List ${startYear}-${endYear}`, header: `${startYear}-${endYear.slice(2)}` });
          // cols.push({ field: `membership_year`, header: `${startYear}-${endYear.slice(2)}` });
          // cols.push({ field: `membership_year `, header: `${startYear}-${endYear}` });
        }
      });
      cols.push({ field: `total`, header: `Total` });

      
      let index = 1;

      for (let i = 0; i < this.filteredPDFData.length; i++) {
          let rowData = {};
          
          if (this.filteredPDFData[i].status === "Approved" || this.filteredPDFData[i].status === "Terminated" || this.filteredPDFData[i].status === "Provisionally Terminated") {
              let total = 0;      
              cols.forEach(col => {
                  if (col.field === 'sr_no') {          
                      rowData[col.field] = index++;
                  } else if (col.field === this.filteredPDFData[i].membership_year) {
                      let headerYears = this.extractYear(col.field);
                      let fieldYears = this.extractYear(this.filteredPDFData[i].membership_year);
      
                      if (headerYears === fieldYears) {
                          if (this.filteredPDFData[i]?.amount && !isNaN(parseFloat(this.filteredPDFData[i]?.amount))) {
                              total += parseFloat(this.filteredPDFData[i]?.amount);
                          }
                          rowData[col.field] = this.filteredPDFData[i].amount || null;
                      }
                  } else if (col.field === 'company_name' || col.field === 'membership_no') {
                      rowData[col.field] = this.filteredPDFData[i][col.field] || null;
                  } else if (col.field === 'total') {
                      rowData[col.field] = total;
                  } else {
                      this.duplicateMember = this.extractYear(col.field, this.filteredPDFData[i]);
                      rowData[col.field] = this.duplicateMember?.amount || null;
      
                      if (this.duplicateMember?.amount && !isNaN(parseFloat(this.duplicateMember?.amount))) {
                          total += parseFloat(this.duplicateMember?.amount);
                      }
                  }
              });
      
              this.pdfData.push(rowData);
          }
      }
      
      
    let exportColumns = cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));


    let index2 = 1; // Initialize index to 1

    for (let i = 0; i < this.filteredPDFData.length; i++) {
        let rowData2 = {};
    
        if (this.filteredPDFData[i].status === "Approved") {
            let total = 0;
    
            cols.forEach(col => {
                if (col.field === 'sr_no') {
                    rowData2[col.field] = index2++;
                } else if (col.field === this.filteredPDFData[i].membership_year) {
                    let headerYears = this.extractYear(col.field);
                    let fieldYears = this.extractYear(this.filteredPDFData[i].membership_year);
    
                    if (headerYears === fieldYears) {
                      if (this.filteredPDFData[i]?.amount && !isNaN(parseFloat(this.filteredPDFData[i]?.amount))) {
                        total += parseFloat(this.filteredPDFData[i]?.amount);
                      }
                        rowData2[col.field] = this.filteredPDFData[i]?.amount || null;
                    }
                } else if (col.field === 'company_name' || col.field === 'membership_no') {
                    rowData2[col.field] = this.filteredPDFData[i]?.[col.field] || null;
                } else if (col.field === 'total') {
                    rowData2[col.field] = total;
                } else {
                    this.duplicateMember = this.extractYear(col.field, this.filteredPDFData[i]);
                    rowData2[col.field] = this.duplicateMember?.amount || null;
    
                    if (this.duplicateMember?.amount && !isNaN(parseFloat(this.duplicateMember?.amount))) {
                      total += parseFloat(this.duplicateMember?.amount);
                    }
                }
            });
    
            this.tableData2.push(rowData2);
        }
    }
    
  let exportColumns2 = cols.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  let index3 = 1; // Initialize index3 to 1

  for (let i = 0; i < this.filteredPDFData.length; i++) {
      let rowData3 = {};
      if (this.filteredPDFData[i].status === "Provisionally Terminated") {
          let total = 0;
          cols.forEach(col => {
              if (col.field === 'sr_no') {
                  rowData3[col.field] = index3++;
              } else if (col.field === this.filteredPDFData[i].membership_year) {
                  let headerYears = this.extractYear(col.field);
                  let fieldYears = this.extractYear(this.filteredPDFData[i].membership_year);
                  if (headerYears === fieldYears) {
                    if (this.filteredPDFData[i]?.amount && !isNaN(parseFloat(this.filteredPDFData[i]?.amount))) {
                      total += parseFloat(this.filteredPDFData[i]?.amount);
                    }
                      rowData3[col.field] = this.filteredPDFData[i]?.amount || null;
                  }
              } else if (col.field === 'company_name' || col.field === 'membership_no') {
                  rowData3[col.field] = this.filteredPDFData[i]?.[col.field] || null;
              } else if (col.field === 'total') {
                  rowData3[col.field] = total;
              } else {
                  this.duplicateMember = this.extractYear(col.field, this.filteredPDFData[i]);
                  rowData3[col.field] = this.duplicateMember?.amount || null;
                  if (this.duplicateMember?.amount && !isNaN(parseFloat(this.duplicateMember?.amount))) {
                    total += parseFloat(this.duplicateMember?.amount);
                  }
              }
          });
          this.tableData3.push(rowData3);
      }
  }
  
  let exportColumns3 = cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
  }));
  
  let index4 = 1;

  for (let i = 0; i < this.filteredPDFData.length; i++) {
    let rowData4 = {};
    if (this.filteredPDFData[i].status == "Terminated") {
      let total = 0;
      cols.forEach(col => {
        if (col.field === 'sr_no') {
          rowData4[col.field] = index4++;
        } else if (col.field === this.filteredPDFData[i].membership_year) {
          let headerYears = this.extractYear(col.field);
          let fieldYears = this.extractYear(this.filteredPDFData[i].membership_year);
          if (headerYears == fieldYears) {
            if (this.filteredPDFData[i]?.amount && !isNaN(parseFloat(this.filteredPDFData[i]?.amount))) {
              total += parseFloat(this.filteredPDFData[i]?.amount);
            }
            rowData4[col.field] = this.filteredPDFData[i]?.amount || null;
          }
        } else if (col.field === 'company_name' || col.field === 'membership_no') {
          rowData4[col.field] = this.filteredPDFData[i]?.[col.field] || null;
        } else if (col.field === 'total') {
          rowData4[col.field] = total;
        } else {
          this.duplicateMember = this.extractYear(col.field, this.filteredPDFData[i]);
          rowData4[col.field] = this.duplicateMember?.amount ? this.duplicateMember?.amount : null;
          if (this.duplicateMember?.amount && !isNaN(parseFloat(this.duplicateMember?.amount))) {
            total += parseFloat(this.duplicateMember?.amount);
          }
        }
      });
      this.tableData4.push(rowData4);
    }
  }
  
let exportColumns4 = cols.map((col) => ({
title: col.header,
dataKey: col.field,
}));


    
// Dictionary to store seen membership numbers
let seenMembershipNumbers: { [key: number]: boolean } = {};

// Remove duplicates from pdfData
this.pdfData = this.pdfData.filter(obj => {
    if (!seenMembershipNumbers[obj.membership_no]) {
        seenMembershipNumbers[obj.membership_no] = true;
        return true; // Keep the object
    }
    return false; // Discard the object
});
let indexs1 = 1;
// Update the sr_no field in pdfData
this.pdfData.forEach(obj => {
    obj.sr_no = indexs1++;
});
// Clear the dictionary for the next iteration
seenMembershipNumbers = {};

// Remove duplicates from tableData2
this.tableData2 = this.tableData2.filter(obj => {
    if (!seenMembershipNumbers[obj.membership_no]) {
        seenMembershipNumbers[obj.membership_no] = true;
        return true; // Keep the object
    }
    return false; // Discard the object
});
let indexs2 = 1;
// Update the sr_no field in pdfData
this.tableData2.forEach(obj => {
    obj.sr_no = indexs2++;
});
// Clear the dictionary for the next iteration
seenMembershipNumbers = {};

// Remove duplicates from tableData3
this.tableData3 = this.tableData3.filter(obj => {
    if (!seenMembershipNumbers[obj.membership_no]) {
        seenMembershipNumbers[obj.membership_no] = true;
        return true; // Keep the object
    }
    return false; // Discard the object
});
let indexs3 = 1;
// Update the sr_no field in pdfData
this.tableData3.forEach(obj => {
    obj.sr_no = indexs3++;
});
seenMembershipNumbers = {};

// Remove duplicates from tableData3
this.tableData4 = this.tableData4.filter(obj => {
    if (!seenMembershipNumbers[obj.membership_no]) {
        seenMembershipNumbers[obj.membership_no] = true;
        return true; // Keep the object
    }
    return false; // Discard the object
});

let indexs4 = 1;
// Update the sr_no field in pdfData
this.tableData4 .forEach(obj => {
    obj.sr_no = indexs4++;
});
      this.api_service.exportPdfForRenewal(
        this.pdfData,
        exportColumns,
        this.tableData2,
        exportColumns2,
        this.tableData3,
        exportColumns3,
        this.tableData4,
        exportColumns4,
        this.route.snapshot.params.slug == 'Hwm'
          ? 'HWM-Membership-Renewal-Report'
          : 'Regular-Membership-Renewal-Report'
      );
      
    }
    else{
      if( this.slug == 'hwm-work-que'){
        let cols = [
          { field: 'sr_no', header: 'S. No.' },
          { field: 'name', header: 'Name of Company' },
          { field: 'request', header: 'Type of Request' },
          { field: 'membership_no', header: 'M. No' },
          { field: 'MF', header: 'MF' },
          { field: 'TDF', header: 'TDF' },
          { field: 'RNF', header: 'RNF' },
          { field: 'REF', header: 'REF' },
          { field: 'document_missing', header: 'Document missing' },
          { field: 'ACM', header: 'Any communication made' },
          { field: 'remark', header: 'Any specific remarks' },
          { field: 'location', header: 'Location' },
          { field: 'remark2', header: 'Remark' },
      ];
      
        let exportColumns = cols.map((col) => ({
          title: col.header,
          dataKey: col.field,
        }));

        for (let i = 0; i < this.memberdata.length; i++) {
          this.pdfData.push({
              sr_no: i + 1,
              name: this.memberdata[i]?.name,
              request: this.memberdata[i]?.request,
              membership_no: this.memberdata[i]?.membership_no,
              ACM: 'Not Available',
              remark: this.memberdata[i]?.location,
              location: this.memberdata[i]?.location,
              ref: this.memberdata[i]?.ref,
              MF: this.memberdata[i]?.mf,
              TDF: this.memberdata[i]?.tdf,
              RNF: this.memberdata[i]?.rnf,
              REF: this.memberdata[i]?.ref,
              document_missing: this.memberdata[i]?.document_missing,
              remark2: this.memberdata[i]?.remark2
          });
      }
      

        this.api_service.exportPdf(
          this.pdfData,
          exportColumns,
          'reports'
        );  
      } 


        if( this.slug == 'voter-list'){
  
  
        let cols = [
    { field: 'sr_no', header: 'Sr No.' },
    { field: 'membership_no', header: 'Membership Number' },
    { field: 'company_name', header: 'Company Name' },
    { field: 'nominee1.name', header: 'First Nominee' },
    { field: 'nominee1.mobile', header: 'First Nominee Mobile No' },
    { field: 'nominee1.email', header: 'First Nominee Email' },
    { field: 'nominee2.name', header: 'Second Nominee' },
    { field: 'nominee2.mobile', header: 'Second Nominee Mobile No' },
    { field: 'nominee2.email', header: 'Second Nominee Email' },
    { field: 'company_address.address', header: 'Address' },
    { field: 'company_address.city', header: 'City' },
    { field: 'member_category.code', header: 'Grade ' },
    { field: 'member_category.name', header: 'Category ' },
    { field: 'member_classification.name', header: 'Classification' },
    { field: 'member_classification.code', header: 'Code' },
    { field: 'member_since', header: 'Year of Joining' },

    // { field: 'email', header: 'Email' },
    // { field: 'website', header: 'Website' },
    // { field: 'office_telephone ', header: 'Office Telephone' }
          ];
         let exportColumns: { title: string; dataKey: string }[];

           exportColumns = cols.map((col) => ({
            title: col.header,
            dataKey: col.field,
          }));
  
          for (let i = 0; i < this.memberdata.length; i++) {
            let rowData = {};
            cols.forEach(col => {
                let value;
                if (col.field === 'sr_no') {
                    value = i + 1;
                } else {
                    let fields = col.field.split('.'); // Split field by dot to handle nested properties
                    value = this.memberdata[i];
                    // Traverse nested properties
                    for (let field of fields) {
                        value = value ? value[field] : null;
                    }
                }
                rowData[col.field] = value || '';
            });
            this.pdfData.push(rowData);
        }
        
        
          this.api_service.exportPdfforVoter(
            this.pdfData,
            exportColumns,
            'Voter-List',
             this.voterYear
          );  
        } 


        if (this.slug == 'membership-approved') {
          let cols = [
              { field: 'sr_no', header: 'S. No.' },
              { field: 'month', header: 'Month' },
              { field: 'membership_no', header: 'Membership No.' },
              { field: 'company_name', header: 'Name of Company' },
              { field: 'city', header: 'Place' },
              { field: 'amount', header: 'Membership Fee' }
          ];
      
          
           let exportColumnss = cols.map(col => ({
            title: col.header,
            dataKey: col.field
        }));
      
          this.pdfData = [];
      
          for (let i = 0; i < this.memberdata.length; i++) {
              let rowData = {};
              cols.forEach(col => {
                  if (col.field === 'sr_no') {
                      rowData[col.field] = i + 1;
                  } else {
                      rowData[col.field] = this.memberdata[i]?.[col.field] || '';
                  }
              });
              this.pdfData.push(rowData);
          }
      
          // Second table data
          let cols1 = [
              { field: 'sr_no', header: 'S. No.' },
              { field: 'particulars', header: 'Particulars' },
              { field: 'details', header: 'Details' }
          ];
      
          let rowData2 = [
              { sr_no: 1, particulars: 'Total Amount Received', details: this.totalData?.total_amount ?? '-' },
              { sr_no: 2, particulars: '20% Amount to be retained by UCCI', details: this.totalData[1]?.retained_amount ?? '-' },
              { sr_no: 3, particulars: 'Balance amount payable to ReSL', details: this.totalData[1]?.balance_amount ?? '-' }
          ];
          let exportColumns2 = cols1.map((col) => ({
            title: col.header,
            dataKey: col.field,
        }));
          // Populate PDF data for the second table
          rowData2.forEach(data => {
              this.pdfData2.push(data);
          });
          // Combine the export columns for both tables
          let exportColumns = [...exportColumnss, ...exportColumns2];
      
          // Export PDF for the first table
          this.api_service.exportPdfforApprovedMember(
              this.pdfData,
              exportColumnss,
              this.pdfData2,
              exportColumns2,
              'Membership-Approved',
              this.rangeDates

          );
      }
      


    if (this.slug === 'member-data') {
  const cols = [
    { field: 'membership_no', header: 'M.No' },
    { field: 'company_name', header: 'Name of Member' },
    { field: 'member_since', header: 'Joining Date' },
    { field: 'email', header: 'Email' },
    { field: 'contact', header: 'Contact' },
    { field: 'factory_address', header: 'Factory Address' },
    { field: 'registered_address', header: 'Registered Address' },
    { field: 'waste_disposal_details', header: 'Waste Disposal Details' },
    { field: 'year', header: 'Year' },
    { field: 'amendment_done', header: 'Amendment done' },
    { field: 'documents_uploaded', header: 'Documents uploaded' },
    { field: 'existing_membership_letters', header: 'Existing and Previous Membership Letters' },
    { field: 'payment_invoices', header: 'Payment Invoices' }
  ];

  const exportColumns = cols.map(col => ({
    title: col.header,
    dataKey: col.field
  }));

  const pdfData = [];

  for (let i = 0; i < this.memeberdatabyid.length; i++) {
    const data = this.memeberdatabyid[i];
    const paymentInvoices = data.payment_invoices || {};

    const wasteDetailsStr = data?.waste_details
      ? JSON.parse(data.waste_details).map(w => `${w.waste_type} (${w.waste_quantity})`).join('; ')
      : '-';

    const changesStr = data?.member_data_changes?.length
      ? data.member_data_changes.map(change => `Year: ${change.change_year}, Fields: ${change.changed_in}`).join('; ')
      : '-';

    const revisionNotesheets = data?.uploaded_documents?.member_data_docs
      ?.map(doc => doc.revision_notesheet)
      .filter(Boolean)
      .join(', ') || '-';

    const invoicesFromDocs = data?.uploaded_documents?.member_data_docs
      ?.map(doc => doc.invoice_pdf)
      .filter(Boolean)
      .join(', ') || '-';

    const revisionLettersStr = (data?.revision_letters || []).join(', ') || '-';

    const memberDataInvoicesStr = (paymentInvoices?.member_data_invoices || []).join(', ') || '-';

    const membershipInvoicesStr = (paymentInvoices?.membership_invoices || [])
      .map(inv => typeof inv === 'string' ? inv : inv?.invoice_pdf)
      .filter(Boolean)
      .join(', ') || '-';

    const rowData = {
      membership_no: data?.membership_no ?? '-',
      company_name: data?.company_name ?? '-',
      member_since: data?.member_since ?? '-',
      email: data?.nominees_info?.emails ?? '-',
      contact: data?.nominees_info?.nominee1_contact ?? '-',
      factory_address: data?.addresses?.factory_address ?? '-',
      registered_address: data?.addresses?.registered_address ?? '-',
      waste_disposal_details: wasteDetailsStr,
      year: data?.created_at ? new Date(data.created_at).getFullYear() : '-',
      amendment_done: changesStr,
      documents_uploaded: invoicesFromDocs || revisionNotesheets,
      existing_membership_letters: revisionLettersStr,
      payment_invoices: `${memberDataInvoicesStr}, ${membershipInvoicesStr}`
    };

    pdfData.push(rowData);
  }

  this.api_service.exportPdf(
    pdfData,
    exportColumns,
    'member-data',
    this.rangeDates
  );
}

    
    
    if (this.slug == 'membership-status') {
      let cols = [
          { field: 'sr_no', header: 'S. No.' },
          { field: 'particular', header: 'Particular' },
          { field: 'Previous', header: 'Previous' },
          { field: 'Current', header: 'Current' },   
      ];
  
      let rowDataa = [
        { sr_no: 1, particular: 'New Memberships', Previous: this.memberdata?.previous_fn_new_member_count ?? '-' ,Current: this.memberdata?.previous_fn_revision_count ?? '-'},
        { sr_no: 2, particular: 'Revision in Memberships', Previous: this.memberdata?.current_fn_new_member_count ?? '-',Current: this.memberdata?.current_fn_revision_count?? '-' },
       
    ];
       let exportColumnss = cols.map(col => ({
        title: col.header,
        dataKey: col.field
    }));
    this.pdfData = [];
    rowDataa.forEach(data => {
      this.pdfData.push(data);
  });
  
  
      // for (let i = 0; i < this.memberdata.length; i++) {
      //     let rowData = {};
      //     cols.forEach(col => {
      //         if (col.field === 'sr_no') {
      //             rowData[col.field] = i + 1;
      //         } else {
      //             rowData[col.field] = this.memberdata[i]?.[col.field] || '';
      //         }
      //     });
      //     this.pdfData.push(rowData);
      // }
  
      // Second table data
      let cols1 = [
          { field: 'sr_no', header: 'S. No.' },
          { field: 'particulars', header: 'Particulars' },
          { field: 'details', header: 'Details' }
      ];
  
      let rowData2 = [
          { sr_no: 1, particulars: 'New Membership Fee', details: this.memberdata?.current_fn_new_membership_total_amount ?? '-' },
          { sr_no: 2, particulars: 'Membership Revision Amount', details: this.memberdata?.current_fn_revision_total_amount ?? '-' },
          { sr_no: 3, particulars: 'Membership Renewal Amount', details: this.memberdata?.current_fn_renewal_amt ?? '-' },
          { sr_no: 4, particulars: 'Trust Development Fee', details:this.memberdata?.current_fn_trust_development_total_amount ?? '-' }

      ];
      let exportColumns2 = cols1.map((col) => ({
        title: col.header,
        dataKey: col.field,
    }));
      rowData2.forEach(data => {
        this.pdfData2.push(data);
    });


//third table
      let cols3 = [
        { field: 'sr_no', header: 'S.No.' },
        { field: 'particulars', header: 'Particulars' },
        { field: 'details', header: 'Details' }
    ];
    
    let rowData3 = [
        { sr_no: 1, particulars: 'Total Members', details: this.memberdata?.total_members ?? '-' },
        { sr_no: 2, particulars: 'Fully Paid', details: this.memberdata?.fully_paid ?? '-' },
        { sr_no: 3, particulars: 'Due', details: this.memberdata?.due ?? '-' }
    ];
     

    let exportColumns3 = cols3.map((col) => ({
      title: col.header,
      dataKey: col.field,
  }));
    

       this.pdfData3=[]
    rowData3.forEach(data => {
      this.pdfData3.push(data);
  });
      // Populate PDF data for the second table
      
      // Combine the export columns for both tables
  
      // Export PDF for the first table
      this.api_service.exportPdfformemberStatus(
          this.pdfData,
          exportColumnss,
          this.pdfData2,
          exportColumns2,
          this.pdfData3,
          exportColumns3,
          'MEMBERSHIP-STATUS',
          this.year
          
      );
  }
    
    }

   
   
   
   


   
   
  }
  onFlatDataExport() {
  if (!this.flatData || this.flatData.length === 0) {
    alert('No data to export.');
    return;
  }
  const exportColumns = Object.keys(this.flatData[0]).map(key => ({
    title: this.toTitleCase(key.replace(/_/g, ' ')),
    dataKey: key
  }));

  this.api_service.exportPdf(
    this.flatData,
    exportColumns,
       this.route.snapshot.params.slug == 'Hwm'
          ? 'HWM-Membership-Renewal-Report'
          : 'Regular-Membership-Renewal-Report'
  );
}
exportFlatDataToExcel() {
  if (!this.flatData || this.flatData.length === 0) {
    alert('No data to export.');
    return;
  }

  // Add "Sr No" to each row
  const formattedData = this.flatData.map((item, index) => ({
    'Sr No': index + 1,
    ...item
  }));

  // Export to Excel using API service
  this.api_service.exportExcel(
    formattedData,
     this.route.snapshot.params.slug == 'Hwm'
          ? 'HWM-Membership-Renewal-Report'
          : 'Regular-Membership-Renewal-Report'
  );
}


// Utility to prettify column titles
toTitleCase(str: string) {
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

 
  getMonthName(timestamp: string): string {
    if (!timestamp) return '-'; // Return '-' if timestamp is not available

    const date = new Date(timestamp);
    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    const monthIndex = date.getMonth();
    const monthName = monthNames[monthIndex];

    return monthName;
  }
  parsedData(data : any, string:any){
    
    if(!data){
       return
    }
    else{
      const d = JSON.parse(data);
      if(string === 'hwm_details'){
          return d?.waste_quantity
      }else if(string === 'member_data'){
          return d?.name1
      }else if (string === 'amendment'){
          return d
      }
      else if (string === 'email1'){
        return d?.email1
    }
    else if (string === 'email2'){
      return d?.email2
  }
    else if (string === 'contact1'){
      return d?.mobile_no1
  }
  else if (string === 'contact2'){
    return d?.mobile_no1
  }
    }
  try {
    return JSON.parse(data).split(',').join(', ');
  } catch {
    return data?.replace(/"/g, '').split(',').join(', ');
  }
    
  }

  extractYear(item: string, data?:any): string {

    if (!item) return '';


    if(data){
      let matchingObjects = this.list.filter(obj => obj.membership_no === data.membership_no);

      for (let obj of matchingObjects) {
          let formattedYearRange =item ;
          if (formattedYearRange === obj.membership_year) {

              return obj; // Return the entire object if membership_year matches\

          }
      }
  
      return null; // Return null if no matching object found
  }
    
    

    let parts = item.split(' ');

    let yearRange = parts[parts.length - 1];

    let years = yearRange.split('-');

     let secondYear = years[1].slice(2);

    let formattedYearRange = years[0] + '-' + years[1];

    return formattedYearRange;
  }

  removeDuplicates(item :any){

  }
showHWMModal: boolean = false;
selectedHWMDetails: any[] = [];

openHWMwasteDetailsModal(details: string) {
  try {
    this.selectedHWMDetails = JSON.parse(details);
    this.showHWMModal = true;
  } catch (e) {
    console.error('Invalid HWM details', e);
    this.selectedHWMDetails = [];
    this.showHWMModal = false;
  }
}
selectedHWMManifestDetails:any;
showHWMManifestModal:boolean=false;

openHWMManifestDetailsModal(detail:string){
  console.log(detail);
  
    try {
    this.selectedHWMManifestDetails = detail;
    console.log(this.selectedHWMManifestDetails,"cjeclked");
    
    this.showHWMManifestModal = true;
  } catch (e) {
    console.error('Invalid HWM details', e);
    this.selectedHWMDetails = [];
    this.showHWMManifestModal = false;
  }
}
selectedManifestDetails:any[]=[]
displayDialog: boolean = false;
showMembershipNo: boolean = true;
openDialog(manifestData: string | any, type: 'manifest' | 'response') {
  try {
    if (typeof manifestData === 'string') {
      this.selectedManifestDetails = type === 'manifest' 
        ? JSON.parse(manifestData) 
        : manifestData;  
    } else {
      this.selectedManifestDetails = manifestData;
    }
    
    this.showMembershipNo = type === 'manifest';
    this.displayDialog = true;
  } catch (e) {
    console.error('Invalid manifest data format', e);
    this.selectedManifestDetails = [];
    this.displayDialog = true;
  }
}

}
